import React, { Component } from "react";
import axios from "axios";
import { getAuthorizationHeader, idEmpresa, URL } from "../../constans/constants";
import { logout } from '../login/SesionService';

class BuscadorPorCedula extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cedula: "",
      resultados: [],
      mostrandoDropdown: false,
      mensaje: "",
    };
    this.timeout = null;
  }

  handleChange = (e) => {
    const valor = e.target.value;
    this.setState({ cedula: valor });

    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (valor.trim() !== "") {
        this.buscarUsuario(valor.trim());
      } else {
        this.setState({
          resultados: [],
          mostrandoDropdown: false,
          mensaje: "",
        });
      }
    }, 500);
  };

  buscarUsuario = async (cedula) => {
    try {
      const res = await axios.get(
        URL + "usuario/obtenerDatosColaborador/" + cedula + "/" + idEmpresa(),
        getAuthorizationHeader()
      );

      if (!res.data.error && res.data.datos) {
        const resultados = Array.isArray(res.data.datos)
          ? res.data.datos
          : [res.data.datos];

        this.setState({
          resultados,
          mostrandoDropdown: true,
          mensaje: "",
        });
      } else {
        this.setState({
          resultados: [],
          mostrandoDropdown: true,
          mensaje: "No se encontraron resultados",
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout();
      }
      this.setState({
        resultados: [],
        mostrandoDropdown: true,
        mensaje: "Error al buscar el usuario",
      });
    }
  };

  seleccionarUsuario = (usuario) => {
    this.setState({
      cedula: usuario.cedula,
      mostrandoDropdown: false,
    });
    if (this.props.onUsuarioSeleccionado) {
      this.props.onUsuarioSeleccionado(usuario);
    }
  };

  limpiarInput = () => {
    this.setState({
      cedula: "",
      resultados: [],
      mostrandoDropdown: false,
      mensaje: "",
    });
  };

  render() {
    const { cedula, resultados, mostrandoDropdown, mensaje } = this.state;

    return (
      <div className="single-select">
        <div className="ci-search" id="ciSearch">
          <span className="material-symbols-outlined ci-search__icon">person</span>
          <input
            type="text"
            className="ci-search__input"
            placeholder="Buscar por Número de CI"
            value={cedula}
            onChange={this.handleChange}
          />

          {cedula && (
            <span
              className="material-symbols-outlined ci-search__clear"
              id="clearButton"
              onClick={this.limpiarInput}
            >
              close
            </span>
          )}

          {mostrandoDropdown && (
            <div className={`ci-search ${mostrandoDropdown ? "searching" : ""}`} id="ciSearch">
              {resultados.length > 0 ? (
                resultados.map((usuario) => (
                  <div
                    key={usuario.id}
                    className="ci-search__option"
                    onClick={() => this.seleccionarUsuario(usuario)}
                    data-ci={usuario.cedula}
                    data-name={usuario.nombreApellido}
                    data-username={usuario.usuario}
                  >
                    <span className="material-symbols-outlined ci-search__option-icon">
                      person
                    </span>
                    <div className="ci-search__option-content">
                      <div className="ci-search__option-name">
                        {usuario.nombreApellido}
                      </div>
                      <div className="ci-search__option-ci">
                        C.I.: {usuario.cedula}
                      </div>
                      <div className="ci-search__option-username">
                        Usuario: {usuario.usuario}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="ci-search__no-results" id="noResults">
                  {mensaje}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default BuscadorPorCedula;